<div class="position-relative">
    <overlay-spinner *ngIf="loading"></overlay-spinner>

    <div class="ws-grid ws-grid--carer" *ngIf="type == 'carer'">
        <cdss-patient-overview-v2-adherence-stat
            type="carer"
            [chapterAdherence]="chapterAdherence"
            [checkinAdherence]="checkinAdherence"
            [disabled]="disabled">
        </cdss-patient-overview-v2-adherence-stat>

        <!-- Carers no longer take PHQ-9 / GAD-7 (the unified weekly check-in has no surveys); show the
             box only for weeks that still carry legacy survey results. -->
        <cdss-patient-overview-v2-surveys *ngIf="weeklySummary?.surveys?.length" [weeklySummary]="weeklySummary" type="carer"></cdss-patient-overview-v2-surveys>
        <div class="ws-grid__spacer" *ngIf="!weeklySummary?.surveys?.length"></div>

        <div class="ws-grid__spacer"></div>
        <div class="ws-grid__spacer"></div>

        <cdss-patient-overview-v2-meal-plan [weeklySummary]="weeklySummary" [isArfid]="isArfid"></cdss-patient-overview-v2-meal-plan>
        <cdss-patient-overview-v2-chapter-progress [weeklySummary]="weeklySummary" type="carer" [careProgramId]="careProgramId"></cdss-patient-overview-v2-chapter-progress>
    </div>

    <div class="ws-grid ws-grid--patient" *ngIf="type == 'patient'">
        <!-- Adherence and Surveys share a height; Chapter progress grows with its chapters on its own. -->
        <div class="ws-grid__pair">
            <cdss-patient-overview-v2-adherence-stat
                type="patient"
                [chapterAdherence]="chapterAdherence"
                [checkinAdherence]="checkinAdherence"
                [foodDiaryCompletion]="foodDiaryCompletion"
                [disabled]="disabled">
            </cdss-patient-overview-v2-adherence-stat>

            <cdss-patient-overview-v2-surveys [weeklySummary]="weeklySummary" type="patient"></cdss-patient-overview-v2-surveys>
        </div>

        <div class="ws-grid__chapter-progress-span">
            <cdss-patient-overview-v2-chapter-progress [weeklySummary]="weeklySummary" type="patient" [careProgramId]="careProgramId"></cdss-patient-overview-v2-chapter-progress>
        </div>
    </div>
</div>
